var RwUtil = (function () {

  // Restituisce url della pagina senza parametri
  var getUrl = function(){
    return 'https://' + window.location.hostname + window.location.pathname;
  }

  // Restituisce parametro url
  // Uso:
  // http://testsite.dvl/?filtro=valore
  // RwUtil.getUrlParam('filtro');
  // restituisce 'valore'

  var getUrlParam = function (sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
  };

  var cleanUrlParam = function () {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
    }
  }

  var setUrlParam = function (newUrl) {
    // window.history.replaceState({}, document.title, newUrl);
    console.log(window.location.toString());
  }


  return {
    getUrl : getUrl,
    getUrlParam : getUrlParam,
    cleanUrlParam : cleanUrlParam,
    setUrlParam : setUrlParam
  }


})();
